import React from 'react'

import InlineTextField from '../components/InlineTextField';

const RetailerEntry = (props) => {

    const handleRetailerGlnChange = (newGln) => {
        props.updateRetailerGln(props.gln, newGln);
    };

    const handleRetailerNameChange = (newName) => {
        props.updateRetailerName(props.gln, newName);
    };

    return (
        <tr>
            <td><InlineTextField value={props.gln} onCommit={handleRetailerGlnChange}/></td>
            <td><InlineTextField value={props.name} onCommit={handleRetailerNameChange}/></td>
            <td>
                <button className="btn btn-danger" onClick={() => props.deleteRetailer(props.gln)}
                        title="Händler löschen">Händler löschen&nbsp;
                    <i className="fa fa-exclamation-triangle">&nbsp;</i>
                </button>
            </td>
        </tr>
    );
};

export default RetailerEntry;



// WEBPACK FOOTER //
// ./src/admin/retailer/RetailerEntry.js